module.exports = __webpack_public_path__ + "static/media/lock.ad214ad8.png";